import { render, staticRenderFns } from "./IngresoRepaletizaje.vue?vue&type=template&id=0c588f74"
import script from "./IngresoRepaletizaje.vue?vue&type=script&lang=js"
export * from "./IngresoRepaletizaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports